/**
 * 날짜/시각 표시 포맷 공용 유틸.
 * 화면 곳곳에 흩어진 `new Date(value).toLocaleString('ko-KR', {...})` 인라인을
 * 한곳으로 모아 출력 포맷을 단일화한다(ko-KR 기준).
 */

/**
 * 날짜+시각 포맷. 예) "2026. 06. 25. 14:30".
 * value가 비면 '-'를 돌려준다(기존 인라인 동작과 동일).
 */
export function formatDateTime(value?: string): string {
    if (!value) return '-'
    return new Date(value).toLocaleString('ko-KR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    })
}

/**
 * 날짜만 포맷(시각 제외). 예) "2026년 6월 25일".
 * value가 비거나 유효하지 않은 날짜면 빈 문자열을 돌려준다(기존 동작과 동일).
 */
export function formatDate(value?: string): string {
    if (!value) return ''
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return ''
    return date.toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    })
}

/**
 * 시각만 포맷(날짜 제외). 예) "14:30".
 * value가 비면 '-'를 돌려준다.
 */
export function formatTime(value?: string): string {
    if (!value) return '-'
    return new Date(value).toLocaleTimeString('ko-KR', {
        hour: '2-digit',
        minute: '2-digit',
    })
}
